module.exports = __webpack_public_path__ + "static/img/Enel_DSC_5194.a21e3e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/Enel_DSC_5194.jpg
// module id = 3dQ1
// module chunks = 0